// extracted by mini-css-extract-plugin
export default {"description":"ForgottenPasswordSetNewPasswordSuccess_description__8bM2i","button":"ForgottenPasswordSetNewPasswordSuccess_button__UFVxq"};